// extracted by mini-css-extract-plugin
export default {"offerImg":"OfferSection_offerImg__KkHdP"};